/**
 * Class applied to selection highlight elements.
 * Renders a blue background with a blue border.
 */
export const HIGHLIGHT_SELECTION_CLASS = 'highlight-selection';

/**
 * Class applied to delete preview highlight elements.
 * Renders a red/danger background with a red border.
 */
export const HIGHLIGHT_DELETE_CLASS = 'highlight-delete';

/**
 * Class applied to the focus box element drawn on top of the active cell.
 */
export const HIGHLIGHT_FOCUS_BOX_CLASS = 'highlight-focus-box';

/**
 * Class applied to the fill handle wrapper. Defines the interactive
 * hit-area, styles the visual handle via pseudo-elements, and intercepts pointer events.
 */
export const HIGHLIGHT_FILL_HANDLE_CLASS = 'highlight-fill-handle';

/**
 * Class applied to the dashed preview box that appears while the user is
 * actively dragging the fill handle.
 */
export const HIGHLIGHT_FILL_PREVIEW_CLASS = 'highlight-fill-preview';

/**
 * Class added to the selections container when a delete intent is active.
 * Used by CSS to override highlight colors to danger/red.
 */
export const HIGHLIGHT_DELETE_INTENT_CLASS = 'highlight-delete-intent';

/**
 * Class added to the scroll container when a highlight is visible.
 * Used by CSS to hide hover elements (add row/column dots).
 */
export const HIGHLIGHT_ACTIVE_CLASS = 'highlight-active';

/**
 * Class added to column-mode highlight elements.
 * Removes the top border so the highlight visually connects with the column header.
 */
export const HIGHLIGHT_COLUMN_CLASS = 'highlight-column';
